import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'; 
import App from './App';
import './index.css';
import { persistor, store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from 'redux-persist/es/integration/react';
import { AppearanceProvider } from './shared/appearance';
const PGate = PersistGate as any
ReactDOM.render(
  <Provider store={store}>
    <PGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <AppearanceProvider>
          <App />
        </AppearanceProvider>
      </React.StrictMode>
    </PGate>
  </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
